export const enum MobileOs {
  Android = 'ANDROID',
  Ios = 'IOS',
}

export function detectMobileOperatingSystem() {
  const userAgent = navigator.userAgent || window.opera

  let mobileOS = null

  if (/android/i.test(userAgent)) {
    mobileOS = MobileOs.Android
  } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    mobileOS = MobileOs.Ios
  }

  const isAndroid = mobileOS === MobileOs.Android
  const isIos = mobileOS === MobileOs.Ios
  const isMobileOS = isAndroid || isIos

  return { isAndroid, isIos, isMobileOS }
}

export function openFile(data: Blob | MediaSource | string) {
  const { isIos } = detectMobileOperatingSystem()
  const url = typeof data === 'string' ? data : URL.createObjectURL(data)

  window.open(url, isIos ? '_self' : '_blank', 'noopener noreferrer')
}
